import React, { useState } from 'react';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import backgroundImage from '../../assets/backgroundImage.webp';
import LeafletEn from '../../assets/2026_Sitare_Admissions_Leaflet.pdf';
import LeafletHi from '../../assets/2026_Sitare_Admissions_Leaflet.pdf';
import { ApplicationsNotOpen } from '../../components/ApplicationsNotOpen';
import { ApplicationsClosed } from '../../components/ApplicationsClosed';
import {
    ADMISSION_YEAR,
    APPLICATION_OPEN_DATE,
    APPLICATION_CLOSE_DATE,
    LEAFLET_DOWNLOAD_FILENAME_EN,
    LEAFLET_DOWNLOAD_FILENAME_HI,
} from '../../constants/dates';

const LoginForm = () => {
    const [phone, setPhone] = useState('');
    const [aadhar, setAadhar] = useState('');
    const [verifying, setVerifying] = useState(true)
    const navigate = useNavigate()
    const handlePhoneNoChange = (event) => {
        const phoneNumber = event.target.value.replace(/\D/, ''); // Remove non-numeric characters
        setPhone(phoneNumber.slice(0, 10)); // Limit to 10 digits
        if (aadhar.length === 12 && phoneNumber.length === 10) {
            setVerifying(false)
        } else {
            setVerifying(true)
        }
    };

    const handleAadharChange = (event) => {
        const aadharNumber = event.target.value.replace(/\D/, ''); // Remove non-numeric characters
        setAadhar(aadharNumber.slice(0, 12)); // Limit to 12 digits
        if (aadharNumber.length === 12 && phone.length === 10) {
            setVerifying(false)
        } else {
            setVerifying(true)
        }
    };

    const sendMessage = async (event) => {
        event.preventDefault()
        localStorage.setItem('currentuser', phone)
        localStorage.setItem('aadhar', aadhar)
        navigate('user-details')
    }

    const currentUrl = window.location.href;
    const isDev = currentUrl.toLowerCase().includes("whale-app") || currentUrl.toLowerCase().includes("localhost")

    const today = new Date();

    if (today < APPLICATION_OPEN_DATE && !isDev) {
        return (
            <ApplicationsNotOpen />
        )
    }

    if (today > APPLICATION_CLOSE_DATE && !isDev) {
        return (
            <ApplicationsClosed />
        )
    }


    return (
        <>
            <Navbar />
            <div style={{ position: 'relative', minHeight: '91vh', overflow: 'hidden' }}>
                {/* Background image */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'grayscale(100%)',
                        opacity: 0.15,
                        zIndex: 0
                    }}
                />

                <h1 className="login-title">Welcome to the Sitare University Application Portal!</h1>
                <h2 className="login-title">Admissions for {ADMISSION_YEAR} are now open</h2>

                {/* Login logic */}
                <div className="login-container">
                    <form className="login-form">

                        <div className="input-group">
                            <label>Mobile Number</label>
                            <input
                                type="tel"
                                value={phone}
                                onChange={handlePhoneNoChange}
                                className="input-field"
                                maxLength={10}
                            />
                        </div>
                        <div className="input-group">
                            <label>Aadhar Number</label>
                            <input
                                type="tel"
                                value={aadhar}
                                onChange={handleAadharChange}
                                className="input-field"
                                maxLength={12}
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={verifying}
                            style={{ cursor: "pointer" }}
                            className={`submit-button ${verifying ? 'disabled' : ''}`}
                            onClick={(e) => sendMessage(e)}
                        >
                            Login
                        </button>
                        {/* Contact & Leaflet Section */}
                        <div className="info-section">
                            <p style={{ margin: '0 0 6px' }}>
                                Questions? Email us at{' '}
                                <a href="mailto:university@sitare.org" className="contact-link">university@sitare.org</a>
                                <br />
                                WhatsApp:{' '}
                                <a href="https://wa.me/+917849910085" className="contact-link">78499 10085</a>
                                <span className="contact-separator">/</span>
                                <a href="https://wa.me/+917849909927" className="contact-link">78499 09927</a>
                            </p>
                            <p style={{ margin: 0 }}>
                                Read our{' '}
                                <a href={LeafletEn} download={LEAFLET_DOWNLOAD_FILENAME_EN} className="leaflet-link">
                                    informational leaflet
                                </a>
                                <br />
                                कृपया हमारा{' '}
                                <a href={LeafletHi} download={LEAFLET_DOWNLOAD_FILENAME_HI} className="leaflet-link">
                                    जानकारी पत्रक
                                </a>
                                {' '}पढ़ें।
                            </p>
                        </div>
                    </form>

                </div>
                <div className="login-footer">
                    Sitare University © {ADMISSION_YEAR}
                </div>
            </div>
        </>
    );
};

export default LoginForm;